import { render, staticRenderFns } from "./MessageButtonsBar.vue?vue&type=template&id=5536cd4b&scoped=true"
import script from "./MessageButtonsBar.vue?vue&type=script&lang=js"
export * from "./MessageButtonsBar.vue?vue&type=script&lang=js"
import style0 from "./MessageButtonsBar.vue?vue&type=style&index=0&id=5536cd4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536cd4b",
  null
  
)

export default component.exports